import { useInfiniteQuery } from '@tanstack/react-query';

import { shouldRetryMe } from '@/hooks/use-auth-state';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

// Paginated only -- unlike connections/reveal-requests, this list has
// exactly one consumer (the blocked-users screen itself), so it needs
// no second "drive to completion" variant (issue #101). Takes
// useAllConnections's retry override (shouldRetryMe -- stop retrying a
// real 4xx/expired-session error rather than TanStack's default
// backoff) since that failure mode is common to every /me/* list.
export function useBlockedUsers() {
  return useInfiniteQuery({
    queryKey: queryKeys.blockedUsers(),
    queryFn: ({ pageParam }) => api.listMyBlocks(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextCursor ? lastPage.nextCursor : undefined),
    retry: shouldRetryMe,
  });
}
